<template lang="pug">
.linha-grafico
    LineGrafico(
        :chart-options='chartOptions',
        :chart-data='chartData',
        :chart-id='chartId',
        :dataset-id-key='datasetIdKey',
        :plugins='plugins',
        :css-classes='cssClasses',
        :styles='styles',
        :width='width',
        :height='height'
    )
</template>

<script>
import { Line as LineGrafico } from 'vue-chartjs/legacy';

import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
} from 'chart.js';

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
);

export default {
    name: 'GraficoLine',
    components: {
        LineGrafico
    },
    props: {
        chartId: {
            type: String,
            default: 'line-chart'
        },
        chartData: {
            type: Object,
            default: () => {}
        },
        chartOptions: {
            type: Object,
            default: () => {}
        },
        datasetIdKey: {
            type: String,
            default: 'line-label'
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 400
        },
        cssClasses: {
            default: '',
            type: String
        },
        styles: {
            type: Object,
            default: () => {}
        },
        plugins: {
            type: Array,
            default: () => []
        }
    }
};
</script>
